export default {
	searchParams: {
		userId: '',
		userName: '',
		deptName: '',
		userGbn: ''
	},
	userList: [],
	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	},

	deptList: []
};
